import en from './lang/en/main';
import mne from './lang/mne/main';

export const messages = {
    en,
    mne,
};
